module.exports = "../fonts/vendor/vendor/typeface-poppins/files/poppins-latin-100italic.woff2?a1c50095d922a8f4222ab83911a13dbd";